import React, { useEffect, useState } from 'react'

import { translateStatus } from 'utils/enumTranslator'

import Box from 'components_new/atoms/Box'

import FitText from 'components_new/molecules/FitText'
import TrendText from 'components_new/molecules/TrendText'

import {
  KeyFigureVisualizationType,
  TCoreWidgetFullyLoaded
} from 'types/GlobalWidget'

import { parseValue, TParsedKpiValues } from '../utils'
import { usePrevious } from 'utils/hooks'

interface MainKpiFocusContainerProps {
  interactive: boolean
  widget: TCoreWidgetFullyLoaded
  scaleFactor: number
  data: TParsedKpiValues[]
  onClick: (option: TParsedKpiValues) => void
  onKpiClick?: (event: React.MouseEvent, option: TParsedKpiValues) => void
}

const MainKpiFocusContainer = (props: MainKpiFocusContainerProps) => {
  const { data, interactive, widget, scaleFactor, onClick, onKpiClick } = props
  const [triggerResize, setTriggerResize] = useState(false)

  const isPublic = location.pathname.includes('public')
  const mainOption = data[0]
  const previousValue = usePrevious(data[0].value)

  useEffect(() => {
    if (previousValue && previousValue !== mainOption.value) {
      setTriggerResize(true)
    }
  }, [mainOption.value, previousValue])

  const clickAvailable =
    interactive &&
    !isPublic &&
    (onKpiClick != null || mainOption.canShowDetails)

  const showComparativePeriod =
    Boolean(widget.settings.comparative_period.selected.value) &&
    data.length > 1

  if (
    mainOption &&
    widget.settings.key_figure_visualization_type ===
      KeyFigureVisualizationType.FOCUS
  ) {
    return (
      <>
        <FitText
          variant="h1"
          onClick={
            clickAvailable
              ? (e) =>
                  onKpiClick ? onKpiClick(e, mainOption) : onClick(mainOption)
              : () => {}
          }
          sx={{
            color: mainOption.status
              ? `${translateStatus[mainOption.status].colorName}.main`
              : undefined,
            cursor: clickAvailable ? 'pointer' : undefined,
            '&:hover': clickAvailable
              ? {
                  color: mainOption.status
                    ? `${translateStatus[mainOption.status].colorName}.light`
                    : 'text.secondary'
                }
              : undefined
          }}
          triggerResize={triggerResize}
          setTriggerResize={setTriggerResize}
        >
          <Box
            component="span"
            sx={{
              display: 'block'
            }}
          >
            {parseValue(mainOption.value)}
            <Box component="span" sx={{ fontSize: '0.6em' }}>
              {' '}
              {mainOption.unit}
            </Box>
          </Box>
        </FitText>
        {showComparativePeriod ? (
          <TrendText
            equivalentFactor={mainOption.equivalentFactor}
            difference={mainOption.difference}
            increaseIsPositive={mainOption.increaseIsPositive}
            numberOfDecimals={mainOption.numberOfDecimals || 0}
            significantFigures={mainOption.significantFigures}
            percentage={mainOption.percentage || 0}
            unitPrefix={mainOption.unitPrefixSelected}
            sx={{
              overflow: 'visible',
              fontSize: `${1.15 * scaleFactor}rem`,
              mb: 2 * scaleFactor
            }}
          />
        ) : null}
      </>
    )
  }

  return null
}

export default MainKpiFocusContainer
